interface BuildJobsListingPathParams {
  basePathname: string;
  filterSlugs: string[];
  page: number;
}

/**
 * Builds a visible jobs listing path without a trailing slash.
 * Appends `/N` only when page > 1 — page 1 omits the number.
 */
export const buildJobsListingPath = ({ basePathname, filterSlugs, page }: BuildJobsListingPathParams): string => {
  const segments = [...basePathname.split('/').filter(Boolean), ...filterSlugs.filter(Boolean), ...(page > 1 ? [String(page)] : [])];

  return `/${segments.join('/')}`;
};
